import { useContext } from "react"
import { Box, TextField, Grid } from "@mui/material"
import { ToolContext } from "../../../../../core/context/ToolContext";
import {Check as CheckIcon, BlockRounded as BlockRoundedIcon} from '@mui/icons-material';

export const FormFooter = ({handleChange, handleDecline, handleSubmit, role}) =>{
    const {reconciliation_state, session_state} = useContext(ToolContext)
    const {navSession} = session_state
    const {reconData, isToReconcile} = reconciliation_state
    
    return (
        <>
            <Grid container spacing={1} >
                {!isToReconcile.data &&<Grid item xs={12}  lg={6}><TextField fullWidth label="Remarks" name="remarks" value={reconData.data.remarks} multiline minRows={2} disabled /></Grid>}
                <Grid item xs={12}  lg={6}><TextField fullWidth label="Reconciled Remarks" disabled={!isToReconcile.data} name="reconciledRemarks" multiline minRows={2} value={reconData.data.reconciledRemarks} onChange={handleChange} /></Grid>
            </Grid>

            {!navSession.data.isShow && isToReconcile.data && role === "Regular User" && (
                <Box sx={{ position: "sticky", left: 0, mt: 2, mb: 4 }}>
                    <Box px={3} py={1.5} display="flex" alignItems="center" justifyContent="center" gap={1} textAlign="center" borderRadius={3} onClick={handleSubmit} sx={{ cursor: "pointer", width: "100%", bgcolor: "primary.main", color: "#fff", fontWeight: 600, fontSize: 15, letterSpacing: 0.5, boxShadow: 2, transition: "all 0.3s ease" }}>
                        <CheckIcon fontSize="small" /> Submit
                    </Box>
                </Box>
            )}

            {!navSession.data.isShow &&((role === "Supervisor" && reconData.data.status === 2) || (role === "Accounting" && reconData.data.status === 3)) && (
                <Box sx={{ position: "sticky", left: 0, mt: 3, mb: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Box px={2.5} py={1} display="flex" alignItems="center" justifyContent="center" gap={1} borderRadius={3} onClick={handleSubmit} sx={{ cursor: "pointer", width: 200, bgcolor: "primary.main", color: "#fff", fontWeight: 600, fontSize: 18, boxShadow: 2, transition: "all 0.3s ease" }}>
                        <CheckIcon fontSize="small" /> {role === "Supervisor" ? "Recommend" : "Approve"}
                    </Box>
                    <Box px={2.5} py={1} display="flex" alignItems="center" justifyContent="center" gap={1} borderRadius={3} onClick={handleDecline} sx={{ cursor: "pointer", width: 200, bgcolor: "error.main", color: "#fff", fontWeight: 600, fontSize: 18, boxShadow: 2, transition: "all 0.3s ease" }}>
                        <BlockRoundedIcon fontSize="small" /> Decline
                    </Box>
                </Box>
            )}
        
        </>
    )
}